import React, {useState} from "react";
import {useSelector} from "react-redux";
import axios from "axios";
import {useForm, Controller} from 'react-hook-form'
import {TextField} from "@material-ui/core";
import useTranslation from "../../effects/use_translation";

const WordCloudForm = ({video_room_id, word_cloud_id, ...props}) => {

  const {handleSubmit, formState: { errors }, setError, control, reset} = useForm({shouldUnregister: true})

  const t = useTranslation(null, true)
  const wordCloud = useSelector((state) => state.wordClouds.find(wc => wc.id == word_cloud_id))
  const videoRoom = useSelector((state) => state.videoRooms.find(vr => vr.id == video_room_id))
  const tagOwner = useSelector((state) => state.tagOwner)
  const wordCloudUrl = useSelector((state) => state.wordCloudUrl).replace("@tag_owner_id@", tagOwner.id).replace("@video_room_id@", videoRoom.id)
  const [sending, setSending] = useState(false)
  const [showThankYou, setShowThankYou] = useState(false)

  const validateForm = (data) => {
    setSending(true)
    // myPlayer.currentTime(180);
    console.log("data", data, wordCloudUrl)

    let payload = data
    payload["tag_owner_id"] = tagOwner.id
    payload["word_cloud_id"] = wordCloud.id

    axios.post(wordCloudUrl, payload).then(response => {
        setSending(false)
        console.log("response", response.data)
        if (response.data.status == "OK") {
          console.log(response.data.question)
          // dispatch(setActiveTab("Question"))
          reset()
          //dispatch(setQuestions(response.data.question))
          setShowThankYou(true)
          setTimeout(function () {
            setShowThankYou(false)
          }, 3000);
        } else {
          console.error(response.data.errors)

          {
            _.map(response.data.errors, (messages, field) => {
              {
                _.map(messages, (message, index) => {
                  console.log("adding error", field, message)
                  setError(field, {type: "not valid", message: message})
                })
              }
            })
          }


          setTimeout(function () {
            let elem = document.getElementsByClassName("Mui-error")
            if (elem && elem.length > 0)
              elem[0].parentElement.scrollIntoView({behavior: 'smooth', block: 'start'})
          }, 200)

        }
      },
      error => {
        alert(error)
        console.error(error)
      }).catch(ex => {
      setSending(false)
      console.error(ex)
    })
  }

  return (
    <div>
      {showThankYou ? (
        <div className="alert alert-success m-3">
          {t("video_room.word_cloud_form.thank_you_text") || "Thank you!"}
        </div>
      ) : (
        <form onSubmit={handleSubmit(validateForm)}>
          <div className="row mt-3">
            <div className="col">
              <span
                style={{color: props.color ? props.color : "white"}}>{wordCloud.form_text || "Add your word to the Word Cloud"}</span>
              <div className="row">
                <div className="col-9 pr-2">
                  <Controller
                    name="word"
                    control={control}
                    defaultValue={""}
                    render={({ field }) => <TextField
                      {...field}
                      readOnly={!sending}
                      disabled={sending}
                      color="primary"
                      required={true}
                      id="word"
                      size="small"
                      error={errors["word"] != null}
                      style={{backgroundColor: "#FFF", marginTop: "5px"}}
                      className="w-100 p-1"
                    />}
                  />
                </div>
                <div className="col-3 pl-0">
                  <button className="btn btn-block btn-stream btn-sm float-right"
                          style={{marginTop: "5px", height: "37px"}} type="submit">
                    <i className="fa fa-angle-right fa-fw"/>
                    <span
                      className="d-none d-xl-inline-block">{" "}{t("video_room.word_cloud_form.send_button_text")}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}

    </div>
  )
}

export default WordCloudForm